import React, { Suspense, useEffect, useState } from 'react'
import { Loading } from 'components/shared'
import { protectedRoutes, publicRoutes } from 'configs/routes.config'
import { useParams } from 'react-router-dom'
import { getAppConfig } from 'configs/app.config'
import useAuth from 'utils/hooks/useAuth'
// import appConfig from 'configs/app.config'
import PageContainer from 'components/template/PageContainer'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ProtectedRoute from 'components/route/ProtectedRoute'
import PublicRoute from 'components/route/PublicRoute'
import AuthorityGuard from 'components/route/AuthorityGuard'
import AppRoute from 'components/route/AppRoute'
import ScrollToTop from 'components/shared/ScrollToTop'

const AllRoutes = (props) => {
    const lang = useSelector((state) => state.locale.currentLang)

    const appConfig = getAppConfig(lang)
    const { unAuthenticatedEntryPath } = appConfig
    const { authenticated } = useAuth()

    const userAuthority = useSelector((state) => state.auth.user.authority)
    const [authenticatedEntryPath, setAuthenticationPath] = useState(lang)
    useEffect(() => {
        const appConfig = getAppConfig(lang)
        setAuthenticationPath(appConfig.authenticatedEntryPath)
    }, [lang])
    return (
        <ScrollToTop>
            <Routes>
                <Route path="/" element={<ProtectedRoute />}>
                    {authenticated && (
                        <>
                            <Route
                                path="/"
                                element={
                                    <Navigate
                                        replace
                                        to={authenticatedEntryPath}
                                    />
                                }
                            />

                            {protectedRoutes.map((route, index) => (
                                <Route
                                    key={route.key + index}
                                    path={route.path}
                                    element={
                                        <AuthorityGuard
                                            userAuthority={userAuthority}
                                            authority={route.authority}
                                        >
                                            <PageContainer
                                                {...props}
                                                {...route.meta}
                                            >
                                                <AppRoute
                                                    routeKey={route.key}
                                                    component={route.component}
                                                    {...route.meta}
                                                />
                                            </PageContainer>
                                        </AuthorityGuard>
                                    }
                                />
                            ))}

                            <Route
                                path="*"
                                element={<Navigate to="/" replace />}
                            />
                        </>
                    )}
                </Route>

                <Route path="/" element={<PublicRoute />}>
                    {publicRoutes.map((route) => (
                        <Route
                            key={route.path}
                            path={route.path}
                            element={
                                <PageContainer {...props} {...route.meta}>
                                    <AppRoute
                                        routeKey={route.key}
                                        component={route.component}
                                        {...route.meta}
                                    />
                                </PageContainer>
                            }
                        />
                    ))}
                </Route>
            </Routes>
        </ScrollToTop>
    )
}

const Views = (props) => {
    return (
        <Suspense fallback={<Loading loading={true} />}>
            <AllRoutes {...props} />
        </Suspense>
    )
}

export default Views
